import { render, staticRenderFns } from "./WvSteakHouseSteakSection.vue?vue&type=template&id=f94be66e&scoped=true"
import script from "./WvSteakHouseSteakSection.vue?vue&type=script&lang=ts"
export * from "./WvSteakHouseSteakSection.vue?vue&type=script&lang=ts"
import style0 from "./WvSteakHouseSteakSection.vue?vue&type=style&index=0&id=f94be66e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94be66e",
  null
  
)

export default component.exports